import { ReactNode } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { BottomNav } from './BottomNav';

// 이 경로들은 자체 헤더가 있으므로 Layout Header를 숨김
const HIDE_HEADER_PATHS = [
  '/scam-check',
  '/report/',
  '/tip/',
  '/boards/',
  '/planner/',
  '/report/write',
  '/tip/write',
  '/map-explore',
];

// 이 경로들은 BottomNav를 숨김
const HIDE_BOTTOMNAV_PATHS = [
  '/report/write',
  '/tip/write',
];

interface LayoutProps {
  children?: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const path = location.pathname;

  const hideHeader = HIDE_HEADER_PATHS.some(p => path.startsWith(p));
  const hideBottomNav = HIDE_BOTTOMNAV_PATHS.some(p => path.startsWith(p));

  return (
    <div className="min-h-screen bg-background max-w-[480px] mx-auto relative">
      {!hideHeader && <Header />}
      <main className={hideBottomNav ? 'pb-4' : 'pb-24'}>
        {children || <Outlet />}
      </main>
      {!hideBottomNav && <BottomNav />}
    </div>
  );
}
